import { Resource as p, API as g } from "@coveo/platform-client";
const t = class t extends p {
  listFacets(e, s, l = !1, o = !1) {
    var a;
    const r = l ? t.getBaseUrlAllOrgs() : t.getBaseUrl(), h = l || o || !!((a = s == null ? void 0 : s.sections) != null && a.includes("INTERNAL"));
    return this.api.post(
      this.buildPath(h ? `${r}/facets` : `${r}/facets/public`, e),
      s
    );
  }
  /**
   * Get a list of the latest activities.
   * @returns Promise<PageModel<ActivityModel>>
   */
  listLatest(e, s) {
    return this.api.post(
      this.buildPath(`${t.getBaseUrl()}/latest`, e),
      s
    );
  }
  /**
   * Fetches activities that a user has subscribed to via the notification service.
   *
   * @param ListActivitiesParams [params]
   * @param ActivityListingFilters [activityFacet]
   * @returns {Promise<PageModel<ActivityModel>>} Paginated list of activities the user is subscribed to.
   */
  listBySubscriptions(e, s) {
    return this.api.post(
      this.buildPath(`${t.getBaseUrl()}/subscriptions/me`, e),
      s
    );
  }
};
t.getBaseUrl = () => `/rest/organizations/${g.orgPlaceholder}/activities`, t.getBaseUrlAllOrgs = () => "/rest/activities";
let i = t;
export {
  i as ActivitiesInternalResource
};
//# sourceMappingURL=ActivitiesInternalResource.js.map
